import { createGlobalStyle } from 'styled-components';

const LockBodyScroll = createGlobalStyle`
  html {
    overflow: hidden;
  }
`;

export default LockBodyScroll;
